<template>
  <div class="app">
    <app-nav></app-nav>

    <introduction-section></introduction-section>
    <map-section></map-section>
    <conclusion-section></conclusion-section>

    <modal name="embed-form" height="auto" :adaptive="true" :pivotY="0.1">
      <embed-form class="px-4 py-3"></embed-form>
    </modal>
  </div>
</template>

<script>
import AppNav from '@/components/AppNav'
import IntroductionSection from '@/components/IntroductionSection'
import MapSection from '@/components/MapSection'
import ConclusionSection from '@/components/ConclusionSection'
import EmbedForm from '@/components/EmbedForm'

import Vue from 'vue'
import Vue2Leaflet from 'vue2-leaflet'
import Vmodal from 'vue-js-modal'

Vue.use(Vmodal)

Vue.component('v-map', Vue2Leaflet.Map)
Vue.component('v-marker', Vue2Leaflet.Marker)
Vue.component('v-popup', Vue2Leaflet.Popup)
Vue.component('v-geojson', Vue2Leaflet.GeoJSON)

export default {
  name: 'App',
  components: {
    AppNav,
    IntroductionSection,
    MapSection,
    ConclusionSection,
    EmbedForm
  }
}
</script>



// WEBPACK FOOTER //
// App.vue?1a08abd7